<script setup lang="ts">
import { Divider } from "~/components/clarity-ui/Divider";
import { Paragraph } from "~/components/clarity-ui/Paragraph";
import CommonLabel from "~/templates/components/CommonLabel.vue";

export interface ProductDeliveryScopeProps {
  productDeliveryScope: string;
}

defineProps<ProductDeliveryScopeProps>();
</script>

<template>
  <div>
    <Paragraph class="font-medium">
      <CommonLabel path="BWF/shop/productDetailPage/productDeliveryScope" />
    </Paragraph>
    <div class="prose mt-2" v-html="productDeliveryScope" />
    <Divider class="mt-6" />
  </div>
</template>
